// Messages for portal/InvoiceDetail (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.invoice_detail.all_invoices': 'All invoices',
  'portal.invoice_detail.download': 'Download PDF',
  'portal.invoice_detail.details': 'Details',
  'portal.invoice_detail.shipment': 'Shipment',
  'portal.invoice_detail.issued_on': 'Issued',
  'portal.invoice_detail.due_on': 'Due',
  'portal.invoice_detail.currency': 'Currency',
  'portal.invoice_detail.tax_rate': 'Tax rate',
  'portal.invoice_detail.charges': 'Charges',
  'portal.invoice_detail.col.description': 'Description',
  'portal.invoice_detail.col.qty': 'Qty',
  'portal.invoice_detail.col.unit': 'Unit price',
  'portal.invoice_detail.col.amount': 'Amount',
  'portal.invoice_detail.no_lines': 'No charges on this invoice.',
  'portal.invoice_detail.subtotal': 'Subtotal',
  'portal.invoice_detail.tax': 'Tax',
  'portal.invoice_detail.total': 'Total',
}

export const zhTW = {
  'portal.invoice_detail.all_invoices': '所有發票',
  'portal.invoice_detail.download': '下載 PDF',
  'portal.invoice_detail.details': '明細',
  'portal.invoice_detail.shipment': '貨件',
  'portal.invoice_detail.issued_on': '開立日期',
  'portal.invoice_detail.due_on': '到期日',
  'portal.invoice_detail.currency': '貨幣',
  'portal.invoice_detail.tax_rate': '稅率',
  'portal.invoice_detail.charges': '費用項目',
  'portal.invoice_detail.col.description': '說明',
  'portal.invoice_detail.col.qty': '數量',
  'portal.invoice_detail.col.unit': '單價',
  'portal.invoice_detail.col.amount': '金額',
  'portal.invoice_detail.no_lines': '此發票沒有費用項目。',
  'portal.invoice_detail.subtotal': '小計',
  'portal.invoice_detail.tax': '稅金',
  'portal.invoice_detail.total': '總計',
}
